import { render, staticRenderFns } from "./BaseTableSelectActionsExpand.vue?vue&type=template&id=01db5b8f&scoped=true"
import script from "./BaseTableSelectActionsExpand.vue?vue&type=script&lang=js"
export * from "./BaseTableSelectActionsExpand.vue?vue&type=script&lang=js"
import style0 from "./BaseTableSelectActionsExpand.vue?vue&type=style&index=0&id=01db5b8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01db5b8f",
  null
  
)

export default component.exports